import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
// import Banner from '../components/layout/partials/Banner';
// import CookieBanner from '../utils/cookies-banner';
// import Banneris from '../components/layout/partials/Banneris';
// import CookieBanner from '../components/elements/CookieBanner';
//
// import Banneris33 from '../components/layout/partials/Banner33';

const LayoutDefault = ({ children }) => (
  <>
    <Header navPosition="right" className="reveal-from-bottom" />

    <main className="site-content">{children}</main>
    {/* <Banneris /> */}
    {/* <Banner /> */}
    {/* <Banneris33 /> */}
    {/* <CookieBanner /> */}
    <Footer />
  </>
);

export default LayoutDefault;
